// extracted by mini-css-extract-plugin
module.exports = {"label-and-loading":"event-selector_label-and-loading__10V53","select":"event-selector_select__1xFGZ"};